import React, { useEffect, useMemo, useState } from 'react';
import _get from 'lodash/get';
import { useSelector } from 'react-redux';

import { getCurrentWorkOrderOp } from 'lib/selectors/getCurrentWorkOrderOp';

import { getWorkOrderOpBadParts } from 'lib/selectors/getWorkOrderOpBadParts';
import { getWorkOrderOpTotalParts } from 'lib/selectors/getWorkOrderOpTotalParts';

import {
  LaborTicketHeaderItem,
  LaborTicketItem,
} from 'components/LaborTicket/styled';
import { useJobDisplayName } from 'lib/hooks/useJobDisplayName';
import Card from '../Card';
import { BodyContainer } from '../styled';

const LaborTicketJobTotal = ({ form }) => {
  const currentWorkOrderOp = useSelector(getCurrentWorkOrderOp);

  const [initialState, setInitialState] = useState({
    workOrderOp: currentWorkOrderOp,
  });

  useEffect(() => {
    setInitialState({
      workOrderOp: currentWorkOrderOp,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { workOrderOp } = initialState;

  const workOrderId = _get(workOrderOp, 'workOrderId');

  const workOrderBadParts = useSelector(getWorkOrderOpBadParts);
  const workOrderGoodParts = useSelector(getWorkOrderOpTotalParts);

  const rejectedParts = form.rejectedParts?.value || 0;
  const goodParts = form.totalParts.value - rejectedParts;

  const totalBadParts = workOrderBadParts + rejectedParts;
  const totalGoodParts = workOrderGoodParts + goodParts;
  const totalParts = totalBadParts + totalGoodParts;

  const { getOrderOpDisplayName } = useJobDisplayName();

  // Memoize the order op display name to avoid re-rendering the component when the work order op changes
  const orderOpDisplayName = useMemo(() => {
    return getOrderOpDisplayName(workOrderOp);
  }, [getOrderOpDisplayName, workOrderOp]);

  return (
    <Card
      header={
        <>
          Job Total
          <LaborTicketHeaderItem
            values={[workOrderId, orderOpDisplayName]}
            separator="|"
          />
        </>
      }
      body={
        <BodyContainer>
          <LaborTicketItem label="Total Parts Produced" value={totalParts} />
          <LaborTicketItem label="Total Good Parts" value={totalGoodParts} />
          <LaborTicketItem label="Total Rejected Parts" value={totalBadParts} />
          <LaborTicketItem
            label="Quantity Required"
            value={workOrderOp?.finishQuantity}
          />
        </BodyContainer>
      }
    />
  );
};

export default LaborTicketJobTotal;
